import { render, staticRenderFns } from "./tagManagement.vue?vue&type=template&id=1c180069&scoped=true&lang=pug"
import script from "./tagManagement.vue?vue&type=script&lang=js"
export * from "./tagManagement.vue?vue&type=script&lang=js"
import style0 from "./tagManagement.vue?vue&type=style&index=0&id=1c180069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c180069",
  null
  
)

export default component.exports